import { gql } from "@apollo/client";

export const USER_QUERY = gql`
 query Me {
    me {
        id
        email
        firstName
        lastName
        role
        companyId
        homeCompanyId
        schema
        subdomain
        phoneNumber
        countryCode
    
        twoFactorEnabled
        aiEnabled
    }
}
`;

/** Generic portal: resolve email → tenant subdomain / redirect URL (no auth). */

export const RESOLVE_LOGIN_SUBDOMAIN_QUERY = gql`
  query ResolveLoginSubdomain($email: String!) {
    resolveLoginSubdomain(email: $email) {
      found
      subdomain
      companyName
      redirectUrl
      requiresSubdomainChoice
      requiresAdminPortal
      message
      adminPortalUrl
      options {
        subdomain
        companyName
        redirectUrl
      }
    }
  }
`;

// export const USER_QUERY = gql`
// query User {
//     user {
//         belongsToCompanyId
//         createdAt
//         deletedAt
//         displayName
//         email
//         emailConfirmed
//         firstName
//         id
//         lastName
//         phone
//         phoneConfirmed
//         role
//         twoFactorEnabled
//         updatedAt
//     }
// }`;

// Company Query

export const COMPANY_QUERY = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      name
      email
        subdomain
        role
        parentCompanyId
        schemaName
        schemaStatus
        address
        city
        state
        country
        zip
      phoneNumber
      notes
        countryCode
        industry
        website
        businessType
        createdAt
        updatedAt
        deletedAt
        inspectionOrderGeneratorEnabled
    }
  }
`;

/**
 * Auth-layer companies (ca_auth) for partner company switching.
 * Must match GraphQL `Company` in auth schema — not the legacy tenant `COMPANIES_QUERY` shape.
 */

export const AUTH_COMPANIES_FOR_PARTNER_QUERY = gql`
  query AuthCompaniesForPartner {
    companies {
      id
      name
      email
      subdomain
      role
      parentCompanyId
      schemaName
      schemaStatus
      address
      city
      state
      country
      zip
      phoneNumber
      industry
      website
      businessType
      createdAt
      updatedAt
    }
  }
`;

// Companies Query


// Manufacturers Query
